import React, {Component, Fragment} from 'react';
import {Button, Card, CardBody, CardTitle, Row} from 'reactstrap';
import {withTranslation} from 'react-i18next';
import {Link} from 'react-router-dom';
import {Colxx, Separator} from '../../../../components/common/CustomBootstrap';
import {reactTableText} from '../../../../constants/configs';
import Breadcrumb from '../../../../containers/navs/Breadcrumb';
import Rbac from '../../../../components/Rbac';
import ReactTable from 'react-table';
import Api from '../../../../services/Api';
import {i18nizeDate} from '../../../../helpers/Utils';
import ModalManager from '../../../../components/modal/ModalManager';
import {NotificationManager} from '../../../../components/common/react-notifications';

class List extends Component {
  constructor(props) {
    super(props);
    this.state = {
      messages: [],
      pages: -1,
      loading: false,
    };
  }

  fetchData = async state => {
    try {
      this.setState({loading: true});
      const offset = state.page * state.pageSize;
      const {data} = await Api.invoke(
        'GET',
        '/admin-ui/general-notifications',
        null,
        {
          params: {
            offset,
            limit: state.pageSize,
          }
        }
      );
      this.setState({
        messages: data.notifications,
        pages: data.totalPage,
      });
    } catch (e) {
      console.log('error: ', e);
    } finally {
      this.setState({
        loading: false,
      });
    }
  };

  deleteNotification = async id => {
    const {t} = this.props;
    try {
      await Api.invoke('DELETE', '/admin-ui/general-notifications', {id});
      NotificationManager.success(t('Notification deleted successfully'), t('Message'));
      this.table.fireFetchData();
    } catch (e) {
      console.log('error: ', e);
    }
  };

  onPressCreate = () => {
    this.props.history.push('/dashboard/notifications/actions/create');
  };

  onPressDelete = id => {
    const {t} = this.props;
    ModalManager.open({
      isOpen: true,
      title: t('Confirm Delete'),
      body: t('Are you sure you want to delete this notifications ?'),
      buttons: [
        {
          color: 'primary',
          onClick: async () => {
            await this.deleteNotification(id);
            ModalManager.close({
              isOpen: false
            });
          },
          text: t('Accept'),
        },
        {
          color: 'grey',
          onClick: () => {
            ModalManager.close({
              isOpen: false
            });
          },
          text: t('Close'),
        },
      ],
    });
  };

  getColumns = t => [
    {
      Header: t('Title'),
      accessor: 'title',
    },
    {
      Header: t('Date'),
      accessor: 'createdAt',
      Cell: props => <span>{i18nizeDate(props.value)}</span>,
    },
    {
      Header: t('Actions'),
      width: 100,
      Cell: props => <div>
        <Rbac permission='delete_general-notifications'>
          <i
            className="simple-icon-trash delete-icon mx-3 cursor-pointer"
            onClick={() => {this.onPressDelete(props.original.id);}}
          />
        </Rbac>
        <Rbac permission='update_general-notifications'>
          <Link to={{
            pathname: '/dashboard/notifications/actions/update',
            state: {
              notification: props.original,
            },
          }}>
            <i className="simple-icon-pencil edit-icon mx-3 cursor-pointer"/>
          </Link>
        </Rbac>
      </div>,
      show: Rbac.hasPermission('update_general-notifications') || Rbac.hasPermission('delete_general-notifications'),
    },
  ];

  render() {
    const {t} = this.props;
    return (
      <Fragment>
        <Row>
          <Colxx xxs="12">
            <Breadcrumb match={this.props.match}/>
            <Separator className="mb-5"/>
          </Colxx>
        </Row>
        <Row>
          <Colxx xxs="12" className="mb-4">
            <Card className="h-100">
              <CardBody>
                <CardTitle className="text-large text-primary d-flex flex-row justify-content-end align-items-center">
                  <Rbac permission='create_general-notifications'>
                    <Button onClick={this.onPressCreate}>
                      <i className="simple-icon-plus add-reply-icon"/>
                      <span className="mx-1">{t('Send New Notification')}</span>
                    </Button>
                  </Rbac>
                </CardTitle>
                <ReactTable
                  manual
                  ref={el => {this.table = el;}}
                  className="-highlight"
                  data={this.state.messages}
                  pages={this.state.pages}
                  loading={this.state.loading}
                  sortable={false}
                  resizable={true}
                  onFetchData={this.fetchData}
                  columns={this.getColumns(t)}
                  defaultPageSize={10}
                  style={{
                    width: '100%'
                  }}
                  {...reactTableText}
                />
              </CardBody>
            </Card>
          </Colxx>
        </Row>
      </Fragment>
    );
  }
}

export default withTranslation()(List);
